import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';

import { Observable, Subscription } from 'rxjs';
import { first } from 'rxjs/operators';
import { difference, isEmpty } from 'lodash';

import { PaginatorComponent, SitesService } from '@nrwl/common-lib';

import { IValueChangedEvent, IWizardContentComponent } from '../../../../wizard.content';
import { PageEvent } from '@angular/material/paginator';

export interface IChooseOptions {
  id?: number;
  name: string;
  description?: string;
  //eslint-disable-next-line @typescript-eslint/no-explicit-any
  siteData: any;
  subtitle?: string;
  //eslint-disable-next-line @typescript-eslint/no-explicit-any
  expandable?: any;
}

@Component({
  selector: 'nrwl-ml-select-site',
  templateUrl: './ml-select-site.component.html',
  styleUrls: ['./ml-select-site.component.scss']
})
export class MlSelectSiteComponent
  implements IWizardContentComponent, AfterViewInit, OnInit, OnDestroy {
  //eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Input() step: any;
  //eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Input() subStep: any;
  //eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Input() wizardCtrl: any;
  @Input() componentId: string;
  // eslint-disable-next-line @angular-eslint/no-output-on-prefix
  @Output() onDataValueChange = new EventEmitter<IValueChangedEvent>();
  @ViewChild('paginator', { static: true }) paginatorComponent: PaginatorComponent;

  //eslint-disable-next-line @typescript-eslint/no-explicit-any
  sitesData: MatTableDataSource<any>;
  displayedColumns: string[] = ['name'];
  sitesDataSubscription: Subscription;
  //eslint-disable-next-line @typescript-eslint/no-explicit-any
  selectedElement: any;
  chosenSiteOption: IChooseOptions;
  hidePaginator = true;
  defaultParams: IChooseOptions;
  chooseOptions: IChooseOptions[] = [
    {
      id: 0,
      name: 'All',
      description: 'All Sites',
      siteData: {
        id: '*',
        name: 'All sites'
      }
    },
    {
      id: 1,
      name: 'Custom',
      description: 'Custom site configuration',
      subtitle: 'Select individual sites',
      siteData: {},
      expandable: {
        value: false
      }
    }
  ];

  get paginatorStatus(): boolean {
    return this.hidePaginator;
  }

  constructor(private sitesService: SitesService) {}

  ngOnInit() {
    this.defaultParams = this.step.parent.defaultParamsById;
    if (this.defaultParams && this.defaultParams.id >= 0) {
      const id = this.defaultParams.id;
      this.onOptionClick(this.chooseOptions[id]);
      this.onRowClick(this.defaultParams.siteData);
    }
  }

  ngAfterViewInit() {
    this.sitesDataSubscription = this.getSites()
      .pipe(first())
      .subscribe(sites => {
        const siteList = sites.filter(site => !site.isDeleted);
        this.sitesData = new MatTableDataSource(siteList);
        this.sitesData.paginator = this.paginatorComponent.paginator;
      });
  }

  nextPage(event: PageEvent): void {
    this.sitesData.paginator.pageIndex = event.pageIndex;
  }

  ngOnDestroy(): void {
    if (this.sitesDataSubscription) {
      this.sitesDataSubscription.unsubscribe();
    }
  }

  // eslint-disable-next-line
  getSites(): Observable<any[]> {
    return this.sitesService.getValuesAsync();
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any,@typescript-eslint/explicit-module-boundary-types
  onOptionClick(chosenOption: any): void {
    this.chosenSiteOption = this.chooseOptions[chosenOption.id];
    this.prepareForChosenSiteOption(chosenOption);
    this.emitSiteOptionChanges();
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any,@typescript-eslint/explicit-module-boundary-types
  applyFilter(filterValue: string): void {
    this.sitesData.filter = filterValue.trim().toLowerCase();

    if (this.sitesData.paginator) {
      this.sitesData.paginator.firstPage();
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any,@typescript-eslint/explicit-module-boundary-types
  onRowClick(data: any): void {
    this.selectedElement = data;
    this.chosenSiteOption.siteData = this.selectedElement;
    this.emitSiteOptionChanges();
  }

  emitSiteOptionChanges(): void {
    const isValid = !isEmpty(this.chosenSiteOption.siteData);
    this.onDataValueChange.emit({
      componentId: this.componentId,
      inputId: 'siteObjectInput',
      key: 'siteObject',
      newValue: this.chosenSiteOption,
      isValid: isValid
    });
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any,@typescript-eslint/explicit-module-boundary-types
  private prepareForChosenSiteOption(chosenOption: any): void {
    if (chosenOption.expandable) {
      chosenOption.expandable.value = true;
      this.chosenSiteOption.siteData = {};
      this.selectedElement = {};
      this.hidePaginator = false;
    } else {
      //eslint-disable-next-line @typescript-eslint/no-explicit-any
      const differentOpt: any = difference(this.chooseOptions, [chosenOption])[0];
      if (differentOpt.expandable) {
        differentOpt.expandable.value = false;
        this.hidePaginator = true;
      }
    }
  }
}
